import _ from 'lodash';
import React from 'react';import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { workOrders } from '../../../modules/customer/profile';
import * as customerSelectors from './../../../modules/customer/profile/selectors';
import { Panel, PanelGroup, Tabs, Tab } from 'react-bootstrap';
import { utcToDisplayDate, utcToDisplayDateAndHour } from './../../../common/formatting';
import Breadcrumbs from '././../../components/Breadcrumbs';
import ProcessSteps from '././../../components/ProcessSteps';
import HardwareList from './../products/hardwareProducts/addHardwareForm/components/HardwareList'
import SMSBox from './../../components/SMSBox'
import LoadingPanel from './../../components/LoadingPanel';
import classnames from 'classnames';
import moment from 'moment';
import { push } from 'connected-react-router';
import { BoxesRow, Box } from '../profilePage/components';

const processStepsDefinition = [
    { name: "NewOrder", mapToName: "NewOrder", displayName: "New Order" },
    { name: "NotRelevant", mapToName: "NewOrder", displayName: "NotRelevant" },
    { name: "TransferredToRelacom", mapToName: "TransferredToRelacom", displayName: "Transferred To Relacom" },
    { name: "Accepted", mapToName: "Accepted", displayName: "Accepted" },
    { name: "CustomerCall_1", mapToName: "CustomerCall_1", displayName: "Customer Call 1" },
    { name: "CustomerCall_2", mapToName: "CustomerCall_2", displayName: "Customer Call 2" },
    { name: "Booked", mapToName: "Booked", displayName: "Booked" },
    { name: "Completed", mapToName: "Completed", displayName: "Completed" },
    { name: "CancelledByCustomer", mapToName: "Completed", displayName: "Cancelled By Customer" },
    { name: "Reopened", mapToName: "NewOrder", displayName: "Reopened" },
    { name: "ShallBeCanceled ", mapToName: "Completed", displayName: "Shall Be Canceled" },
    { name: "CancelRequestTransferred", mapToName: "Completed", displayName: "Cancel Request Transferred" },
    { name: "CompletedOnSite", mapToName: "Completed", displayName: "Completed On Site" },
    { name: "CancelledWrongCustInfo", mapToName: "Completed", displayName: "Cancelled Wrong Customer Info" },
    { name: "CompletedLTANo", mapToName: "Completed", displayName: "Completed LTA No" },
    { name: "CompletedLTAYes", mapToName: "Completed", displayName: "Completed LTA Yes" },
    { name: "AddressChangeTransferred", mapToName: "Completed", displayName: "Address Change Transferred" }
]

export const minDateForActiveOrders = moment().subtract(14, 'd');

function mapDevicesProperties(devices) {
    let result = [];
    _.forEach(devices, function (device, key) {
        result.push({ name: device.technicalProductName, serialNumber: device.deviceSerialNumber });
    });
    return result;
}

const createActionsList = (order) => {
    if (order === undefined || order.changeHistory === undefined)
        return undefined;
    let actionsList = [];
    _.forEach(order.changeHistory, function (historyEntry, key) {
        actionsList.push({
            status: historyEntry.status,
            actionTaken: historyEntry.actionTaken,
            date: historyEntry.eventDateTime,
            description: historyEntry.description
        });
    });
    return actionsList;
}

const createDescriptionBoxContent = (actionsList) => {
    let boxText = "";
    _.forEach(actionsList, function (action, key) {
        if (action.description !== "")
            boxText = boxText + "Status: " + action.status + " (" + utcToDisplayDateAndHour(action.date) + ")" + "\nDescription: " + action.description + "\n\n";
    });
    return boxText;
}

const createActionBoxContent = (actionsList) => {
    let boxText = "";
    _.forEach(actionsList, function (action, key) {
        if (action.actionTaken !== "")
            boxText = boxText + "Status:" + action.status + " (" + utcToDisplayDateAndHour(action.date) + ")" + "\nAction: " + action.actionTaken + "\n\n";
    });
    return boxText;
}

const WorkgOrders = ({customerId, orders, activeTabOrder, activeOrderDevices, previousTabOrder, selectedTabName, setActiveOrder, setPreviousOrder, setActiveTab, isLoading, backToProfileView}) => {

    let isPreviousOrderView = selectedTabName === "Previous";
    let selectedOrder = isPreviousOrderView ? previousTabOrder : activeTabOrder;
    let currentStatus = selectedOrder !== undefined ? _.find(selectedOrder.changeHistory, order => order.status === selectedOrder.currentStatus) : undefined;
    let activeOrders = workOrders.selectors.getActiveWorkOrdersList(orders);
    let previousOrders = workOrders.selectors.getPreviousWorkOrdersList(orders);
    let actionsList = createActionsList(selectedOrder);
    let workOrderFormClass = classnames({
        'workOrders col-xs-12': true,
        'disabledOrder': false, //isPreviousOrderView,
    });
    return (
        <BoxesRow>
            <Box label="Work orders" className="work-orders">
                {isLoading &&
                    <LoadingPanel />
                }
                {!isLoading && selectedOrder !== undefined &&
                    <div>
                        <div className="col-md-2 col-xs-12 orders-column">
                            <Tabs defaultActiveKey={selectedTabName} id="order-tabs" onSelect={(tab) => setActiveTab(tab)}>
                                <Tab title={"Active (" + activeOrders.length + ")"} eventKey="Active">
                                    {activeOrders.length > 0 &&
                                        <PanelGroup activeKey={selectedOrder.id} accordion>
                                            {activeOrders.map((order, index) => {
                                                let arrowButtonClass = classnames({
                                                    'glyphicon': true,
                                                    'glyphicon-triangle-bottom': order.id === selectedOrder.id,
                                                    'glyphicon-triangle-right': order.id !== selectedOrder.id
                                                });
                                                return (
                                                    <Panel
                                                        key={index}
                                                        header={<span>Work order: {order.id} <span className={arrowButtonClass}></span></span>}
                                                        eventKey={order.id}
                                                        collapsible={true}
                                                        onSelect={e => setActiveOrder(order.id)}>
                                                        <ProcessSteps
                                                            stepsDefinitions={processStepsDefinition}
                                                            stepsList={order.changeHistory}
                                                            currentStepName={order.currentStatus}
                                                            />
                                                    </Panel>
                                                )
                                            })
                                            }
                                            <span></span>
                                        </PanelGroup>
                                    }
                                    {activeOrders.length === 0 &&
                                        <div className="no-orders-message alert alert-warning">
                                            No active orders, check "Previous" tab for historical orders
                                        </div>
                                    }
                                </Tab>
                                <Tab title={"Previous (" + previousOrders.length + ")"} eventKey="Previous" >
                                    {previousOrders.length > 0 &&
                                        <table className="previous-orders table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Dato:</th>
                                                    <th>ID:</th>
                                                    <th>Status:</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    previousOrders.map((order, index) => {
                                                        let rowClass = classnames({
                                                            'selected': order.id === selectedOrder.id,
                                                        });
                                                        return (
                                                            <tr key={index} className={rowClass} onClick={e => setPreviousOrder(order.id)}>
                                                                <td>
                                                                    {utcToDisplayDate(order.registeredDateTime)}
                                                                </td>
                                                                <td className="order-id-column">
                                                                    {order.id}
                                                                </td>
                                                                <td>
                                                                    {order.currentStatus.split(/(?=[A-Z])/).join(" ")}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    }
                                    {previousOrders.length === 0 &&
                                        <div className="no-orders-message alert alert-warning">
                                            No historical orders
                                        </div>
                                    }
                                </Tab>
                            </Tabs>
                        </div>
                        <div className="col-md-4 col-xs-12 details-column first-column">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="details-row">
                                        <h4>Order:</h4>
                                        {selectedOrder.id !== 0 &&
                                            <div className="order">{selectedOrder.id}</div>
                                        }
                                    </div>
                                    {selectedOrder.serviceType !== undefined &&
                                        <div className="details-row">
                                            <h4>Service Type:</h4>
                                            <div className="service-type">
                                                {selectedOrder.serviceType.split(/(?=[A-Z])/).join(" ")}
                                            </div>
                                        </div>
                                    }
                                    {selectedOrder !== undefined && selectedOrder.services &&
                                        <div className="details-row">
                                            <h4>Connected Devices: </h4>
                                            <div className="row details-row">
                                                <div className="hardwareProduct col-xs-12">
                                                    <HardwareList hardwareList={mapDevicesProperties(selectedOrder.services)} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-12 details-column">
                            <div className="row">
                                <div className="col-xs-12 details-row">
                                    <h4>Adresse:</h4>
                                    {
                                        selectedOrder.address !== undefined &&
                                        <div className="address">
                                            <div>{selectedOrder.address.street} {selectedOrder.address.streetLetter}{selectedOrder.address.streetNo},</div>
                                            <div>{selectedOrder.address.zip} {selectedOrder.address.city}</div>
                                        </div>
                                    }
                                </div>
                                {actionsList !== undefined &&
                                    <div className="col-xs-12 details-row">
                                        <h4>Description:</h4>
                                        <div className="description-box">
                                            <textarea
                                                disabled
                                                placeholder="No descriptions available"
                                                value={createDescriptionBoxContent(actionsList)}>
                                            </textarea>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-12 details-column">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="details-row">
                                        <h4>Work Order Status:</h4>
                                        {currentStatus !== undefined &&
                                            <div className="process-steps full-width">
                                                <div className="process-step">
                                                    <button disabled type="button" className="btn btn-primary btn-circle step circle-medium active-step order-status"></button>
                                                    <div className="order-status details active-step">
                                                        <div className="step-name">{currentStatus.status}</div>
                                                        <div className="date">{utcToDisplayDateAndHour(currentStatus.eventDateTime)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {actionsList !== undefined &&
                                        <div className="details-row">
                                            <h4>Actions Taken:</h4>
                                            <div className="action-box">
                                                <textarea
                                                    disabled
                                                    placeholder="No actions available"
                                                    value={createActionBoxContent(actionsList)}>
                                                </textarea>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Box>
        </BoxesRow>
    )
};

const mapStateToProps = createStructuredSelector({
    customerId: customerSelectors.getCustomerID,
    orders: workOrders.selectors.getWorkOrders,
    activeTabOrder: workOrders.selectors.getActiveWorkOrder,
    previousTabOrder: workOrders.selectors.getPreviousWorkOrder,
    selectedTabName: workOrders.selectors.getSelectedTabName,
    isLoading: workOrders.selectors.isLoading
});

const mapDispatchToProps = (dispatch, props) => ({
    setActiveOrder: (orderId) => dispatch(workOrders.actions.setActiveOrder(orderId)),
    setPreviousOrder: (orderId) => dispatch(workOrders.actions.setPreviousOrder(orderId)),
    setActiveTab: (selectedTabName) => dispatch(workOrders.actions.setActiveTab(selectedTabName)),
    backToProfileView: (customerId) => dispatch(push(`/customer/${customerId}`))
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkgOrders)